import { render, staticRenderFns } from "./showNotifications.vue?vue&type=template&id=5d77e94c&scoped=true"
import script from "./showNotifications.vue?vue&type=script&lang=js"
export * from "./showNotifications.vue?vue&type=script&lang=js"
import style0 from "./showNotifications.vue?vue&type=style&index=0&id=5d77e94c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d77e94c",
  null
  
)

export default component.exports